import React from 'react';

const UserName = ({ name }: { name: string }) => {
  return <span className='user-name'>{name}</span>;
};

export default UserName;
